import { render, staticRenderFns } from "./PrizeMore.vue?vue&type=template&id=f085bc4a&scoped=true&"
import script from "./PrizeMore.vue?vue&type=script&lang=ts&"
export * from "./PrizeMore.vue?vue&type=script&lang=ts&"
import style0 from "./PrizeMore.vue?vue&type=style&index=0&id=f085bc4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f085bc4a",
  null
  
)

export default component.exports